export const shirt = [0.75, 0.2, 0.15];
